import type { ReactNode } from "react";
import { Box } from "@mui/material";
import LoadingSpinner from "../LoadingSpinner/default-spinner.component";

type KeycloakReadyProps = {
  keycloakReady: boolean;
  children: ReactNode;
};

export default function KeycloakReady({ keycloakReady, children }: Readonly<KeycloakReadyProps>) {
  // As long as keycloak is not done keep spinner so app does not crash and keeps responsive
  if (!keycloakReady) {
    return (
      <Box
        data-testid="keycloak-ready-spinner"
        sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}
      >
        <LoadingSpinner size={60} />
      </Box>
    );
  }

  return <>{children}</>;
}
